import { DocumentPlusIcon, ArrowDownTrayIcon, FolderOpenIcon, PlayIcon, ArrowUpTrayIcon, ArrowDownTrayIcon as DownloadIcon, ArrowUturnLeftIcon, ArrowUturnRightIcon } from '@heroicons/react/24/outline';

interface EditorToolbarProps {
  onNew: () => void;
  onSave: () => void;
  onLoad: () => void;
  onTest: () => void;
  onExport: () => void;
  onImport: () => void;
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
  isDirty: boolean;
}

export function EditorToolbar({
  onNew,
  onSave,
  onLoad,
  onTest,
  onExport,
  onImport,
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  isDirty
}: EditorToolbarProps) {
  return (
    <div className="editor-toolbar">
      <div className="toolbar-group">
        <button onClick={onNew} title="New Level (Ctrl+N)">
          <DocumentPlusIcon style={{ width: '16px', height: '16px' }} /> New
        </button>
        <button onClick={onSave} title="Save Level (Ctrl+S)" disabled={!isDirty}>
          <ArrowDownTrayIcon style={{ width: '16px', height: '16px' }} /> Save {isDirty && '*'}
        </button>
        <button onClick={onLoad} title="Load Level">
          <FolderOpenIcon style={{ width: '16px', height: '16px' }} /> Load
        </button>
      </div>

      <div className="toolbar-group">
        <button onClick={onUndo} title="Undo (Ctrl+Z)" disabled={!canUndo}>
          <ArrowUturnLeftIcon style={{ width: '16px', height: '16px' }} /> Undo
        </button>
        <button onClick={onRedo} title="Redo (Ctrl+Y)" disabled={!canRedo}>
          <ArrowUturnRightIcon style={{ width: '16px', height: '16px' }} /> Redo
        </button>
      </div>

      <div className="toolbar-group">
        <button onClick={onTest} title="Test Level (Ctrl+T)" className="test-btn">
          <PlayIcon style={{ width: '16px', height: '16px' }} /> Test
        </button>
      </div>

      <div className="toolbar-group">
        <button onClick={onExport} title="Export Level JSON">
          <ArrowUpTrayIcon style={{ width: '16px', height: '16px' }} /> Export
        </button>
        <button onClick={onImport} title="Import Level JSON">
          <DownloadIcon style={{ width: '16px', height: '16px' }} /> Import
        </button>
      </div>
    </div>
  );
}
